import { useState } from "react";
import { cn } from "@/lib/utils";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";

/** Lazy image with skeleton placeholder and soft fade-in. */
export function ProgressiveImage({
  src,
  alt = "",
  className = "",
  wrapperClassName = "",
  loading = "lazy",
  ...props
}) {
  const reduced = usePrefersReducedMotion();
  const [loaded, setLoaded] = useState(!src);

  if (!src) {
    return (
      <div
        className={cn("flex items-center justify-center bg-zinc-100 text-xs text-zinc-400", wrapperClassName)}
        aria-hidden
      />
    );
  }

  return (
    <div className={cn("relative overflow-hidden bg-zinc-100", wrapperClassName)}>
      {!loaded && !reduced ? (
        <div className="absolute inset-0 animate-pulse bg-gradient-to-br from-zinc-100 via-zinc-200/60 to-zinc-100" />
      ) : null}
      <img
        src={src}
        alt={alt}
        loading={loading}
        decoding="async"
        onLoad={() => setLoaded(true)}
        className={cn(
          className,
          !reduced && "transition-opacity duration-300 ease-out",
          loaded || reduced ? "opacity-100" : "opacity-0",
        )}
        {...props}
      />
    </div>
  );
}
